import React, { useState, useEffect } from "react";
import { getStockReg } from "../../../api/endpoints/allReports";
import { authSelector } from "../../../store/selectors/index";
import { useSelector } from "react-redux";
import { message, Select } from "antd";
import SideBar from "../../sidebar/sideBar";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { getSite } from "../../../api/endpoints/refrences";
import { getAllBookings } from "../../../api/endpoints/booking";

const { Option } = Select;

const BookingEvents = () => {
  const { user, access_token } = useSelector(authSelector);
  const [siteName, setSiteName] = useState();
  const [siteAddress, setSiteAddress] = useState();
  const [state, setState] = useState({
    startingDate: "",
    endingDate: "",
    bookingId: "",
    bookings: [],
    reportType: "0"
  });

  const [itemsQueue, setItemsQueue] = useState([]);
  const [loading, setLoading] = useState(false);

  const onChangeText = (e) => {
    const { name, value } = e.target;
    setState({ ...state, [name]: value });
  };

  const getAllData = async () => {
    const _bookings = await getAllBookings(access_token);
    setState({
      ...state,
      bookings: _bookings,
    });
  };
  useEffect(() => {
    getAllData();

    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const editHandler = async () => {
  // ✅ Validate input
  if ((!state.startingDate && state.endingDate) || (state.startingDate && !state.endingDate)) {
    return message.error("Please select both Starting and Ending Dates!");
  }

  // ✅ Prepare payload
  const data = {
    BookingID: state.bookingId ? Number(state.bookingId) : null,
    StartingDate: state.startingDate || null,
    EndingDate: state.endingDate || null,
      reportType: Number(state.reportType),
  };

  try {
    setLoading(true);

    // ✅ Call your API for booking summary
    const results = await getStockReg(data, access_token); // <-- use your booking API

    if (results.success && results.data.length > 0) {
      const payload = results.data.map((curr) => ({
        BookingID: curr.BookingID,
        TDate: curr.TDate,
        CName: curr.CName,
        Event: curr.Event,
        CPRSN: curr.CPRSN,
        EventDate: curr.EventDate,
        TotalBookedAmount: Number(curr.Total_Booked_Amount || 0),
        TotalAmount: Number(curr.TotalAmount || 0),
        TotalReceived: Number(curr.Total_Received || 0),
        TotalReturned: Number(curr.Total_Returned || 0),
        RemainingBalance: Number(curr.Remaining_Balance || 0),
        ClosedStatus: curr.ClosedStatus,
      }));

      setItemsQueue(payload);
      if (state.reportType === "0") {
        generatePDF(payload);
        } else {
          generatePDFEventWise(payload);
        } // your existing PDF logic
    } else {
      message.warning(results.message || "No records found for the given filters!");
    }
  } catch (err) {
    console.error(err);
    message.error("Something went wrong while fetching report!");
  } finally {
    setLoading(false);
  }
};

  const clearState = () => {
    setItemsQueue([]);
    setState({ startingDate: "", endingDate: "", bookingId: "0" });
  };

  const getName = async () => {
    const result = await getSite(access_token);
    if (result.success) {
      setSiteName(result.data[0].Name);
      setSiteAddress(result.data[0].Address);
    } else {
      message.error(result.message);
    }
  };

  useEffect(() => {
    getName();
  }, []);

  const formatDate = (dateStr) => {
    const options = { year: "numeric", month: "long", day: "numeric" };
    const formattedDate = new Date(dateStr).toLocaleDateString(
      undefined,
      options
    );
    return formattedDate;
  };

  const formatValue = (val) => {
    return val && val !== 0 ? Number(val).toLocaleString() : ""; // return empty string if 0 or null
  };

  // Acording to ICODE Wise
const generatePDF = (data) => {
  if (!data || data.length === 0) {
    message.error("No data to generate report!");
    return;
  }

  const doc = new jsPDF("l", "mm", "a4");

  // ====== Header ======
  const now = new Date();
  const printDateTime = `${now.toLocaleDateString()} ${now.toLocaleTimeString()}`;

  doc.setFontSize(8);
  doc.text(`Printed on: ${printDateTime}`, 280, 10, { align: "right" });

  doc.setFontSize(16);
  doc.text(siteName || "", 148, 11, { align: "center" });

  doc.setFontSize(12);
  doc.text(siteAddress || "", 148, 16, { align: "center" });

  doc.setFontSize(10);
  doc.text(
    `Booking Payment Summary Report`,
    148,
    21,
    { align: "center" }
  );

  if (state.startingDate && state.endingDate) {
    doc.setFontSize(9);
    doc.text(
      `From: ${formatDate(state.startingDate)} To: ${formatDate(state.endingDate)}`,
      148,
      26,
      { align: "center" }
    );
  }

  // ====== Prepare Table Rows ======
  const tableRows = data.map((r) => [
    r.BookingID,
    formatDate(r.TDate),
    r.CName || "",
    r.Event || "",
    formatDate(r.EventDate),
    // r.EventDate || "",
    r.TotalBookedAmount?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
    r.TotalReceived?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
    r.TotalBookedAmount - r.TotalReceived,
    r.TotalReturned?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
    (r.TotalReceived - r.TotalReturned).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
    // r.RemainingBalance?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
    // r.ClosedStatus ? "Closed" : "Open",
  ]);

  // ====== Totals Row ======
  const totalBooked = data.reduce((sum, r) => sum + (r.TotalBookedAmount || 0), 0);
  const totalReceived = data.reduce((sum, r) => sum + (r.TotalReceived || 0), 0);
  const totalReturned = data.reduce((sum, r) => sum + (r.TotalReturned || 0), 0);
  const totalRemaining = data.reduce((sum, r) => sum + (r.RemainingBalance || 0), 0);
  const totalInc = totalReceived - totalReturned;
  const totalBal = totalBooked - totalReceived;


  tableRows.push([
    { content: "Grand Total", colSpan: 5, styles: { halign: "right", fontStyle: "bold" } },
    totalBooked.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
    totalReceived.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
    totalBal.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
    totalReturned.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
    totalInc.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
    "",
  ]);

  // ====== Render Table ======
  autoTable(doc, {
    head: [
      [
        "B_ID",
        "Date",
        "Name",
        "Event",
        "EDate",
        "Booked",
        "Received",
        "Balance",
        "Total Exp",
        "Income",
        // "Status",
      ],
    ],
    body: tableRows,
    startY: 30,
    theme: "grid",
    margin: { left: 5, right: 5 },
    styles: {
      fontSize: 9,
      cellPadding: 1,
      textColor: [0, 0, 0],
      lineColor: [0, 0, 0],
      lineWidth: 0.3,
      valign: "middle",
    },
    headStyles: {
      fillColor: [255, 255, 255],
      textColor: [0, 0, 0],
      fontStyle: "bold",
      halign: "center",
      lineColor: [0, 0, 0],
      lineWidth: 0.5,
    },
    columnStyles: {
      0: { halign: "center", cellWidth: 15 },
      1: { halign: "center", cellWidth: 30 },
      2: { halign: "center", cellWidth: 30 },
      3: { halign: "center", cellWidth: 15 },
      4: { halign: "center", cellWidth: 30 },
      5: { halign: "right", cellWidth: 30 },
      6: { halign: "right", cellWidth: 30 },
      7: { halign: "right", cellWidth: 35 },
      8: { halign: "right", cellWidth: 35 },
      9: { halign: "right", cellWidth: 35 },
    },
    didParseCell: (data) => {
      // Make last row (Grand Total) bold
      if (data.row.index === tableRows.length - 1) {
        data.cell.styles.fontStyle = "bold";
        data.cell.styles.fillColor = [235, 235, 235];
      }
    },
  });

  // ====== Open PDF in new tab ======
  const pdfBlob = doc.output("blob");
  const pdfUrl = URL.createObjectURL(pdfBlob);
  window.open(pdfUrl);
};

const generatePDFEventWise = (data) => {
  if (!data || data.length === 0) {
    message.error("No data to generate report!");
    return;
  }

  const doc = new jsPDF("p", "mm", "a4");

  // ====== Header ======
  const now = new Date();
  const printDateTime = `${now.toLocaleDateString()} ${now.toLocaleTimeString()}`;

  doc.setFontSize(8);
  doc.text(`Printed on: ${printDateTime}`, 180, 10, { align: "right" });

  doc.setFontSize(16);
  doc.text(siteName || "", 102, 11, { align: "center" });

  doc.setFontSize(12);
  doc.text(siteAddress || "", 102, 16, { align: "center" });

  doc.setFontSize(10);
  doc.text(
    `Booking Details`,
    102,
    21,
    { align: "center" }
  );

  if (state.startingDate && state.endingDate) {
    doc.setFontSize(9);
    doc.text(
      `From: ${formatDate(state.startingDate)} To: ${formatDate(state.endingDate)}`,
      102,
      26,
      { align: "center" }
    );
  }

  // ====== Prepare Table Rows ======
  const tableRows = data.map((r) => [
    r.BookingID,
    formatDate(r.TDate),
    r.CName || "",
    r.Event || "",
    r.CPRSN || "",
    formatDate(r.EventDate),
    // r.EventDate || "",
    r.TotalAmount?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
  ]);

  // ====== Totals Row ======
  const totalBooked = data.reduce((sum, r) => sum + (r.TotalAmount || 0), 0);
 


  tableRows.push([
    { content: "Grand Total", colSpan: 6, styles: { halign: "right", fontStyle: "bold" } },
    totalBooked.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
     "",
  ]);

  // ====== Render Table ======
  autoTable(doc, {
    head: [
      [
        "B_ID",
        "Date",
        "Name",
        "Event",
        "Menu",
        "Event Date",
        "Booked In",
      ],
    ],
    body: tableRows,
    startY: 30,
    theme: "grid",
    margin: { left: 10, right: 0 },
    styles: {
      fontSize: 9,
      cellPadding: 1,
      textColor: [0, 0, 0],
      lineColor: [0, 0, 0],
      lineWidth: 0.3,
      valign: "middle",
    },
    headStyles: {
      fillColor: [255, 255, 255],
      textColor: [0, 0, 0],
      fontStyle: "bold",
      halign: "center",
      lineColor: [0, 0, 0],
      lineWidth: 0.5,
    },
    columnStyles: {
      0: { halign: "center", cellWidth: 15 },
      1: { halign: "center", cellWidth: 30 },
      2: { halign: "center", cellWidth: 30 },
      3: { halign: "center", cellWidth: 15 },
      4: { halign: "center", cellWidth: 30 },
      5: { halign: "right", cellWidth: 30 },
      6: { halign: "right", cellWidth: 30 },
    },
    didParseCell: (data) => {
      // Make last row (Grand Total) bold
      if (data.row.index === tableRows.length - 1) {
        data.cell.styles.fontStyle = "bold";
        data.cell.styles.fillColor = [235, 235, 235];
      }
    },
  });

  // ====== Open PDF in new tab ======
  const pdfBlob = doc.output("blob");
  const pdfUrl = URL.createObjectURL(pdfBlob);
  window.open(pdfUrl);
};

  return (
    <>
      <div className="flex bg-black main">
        <SideBar />
        <div className="h-full flex flex-col content-center w-full">
          <div className="flex justify-center mt-32">
            <div className="meterTableMain flex flex-col w-1/2 ml-10 mt-5 mr-10">
              <div className="bg-blue-500 headingBox flex justify-center">
                <h1 className="text-white">Booking Details</h1>
              </div>
              <div className="flex flex-col h-52 items-center justify-evenly">
                <div>
                  <label className="text-white">Starting Date:</label>
                  <input
                    name="startingDate"
                    type="date"
                    className="text-black inpTxt p-2 h-8 ml-3 mb-3"
                    value={state.startingDate}
                    onChange={onChangeText}
                  />
                </div>
                <div>
                  <label className="text-white">Ending Date:</label>
                  <input
                    name="endingDate"
                    type="date"
                    className="text-black inpTxt p-2 h-8 ml-3 mb-3"
                    value={state.endingDate}
                    onChange={onChangeText}
                  />
                </div>
                <div className="flex">
                   <div>

                  <Select
                    showSearch
                    placeholder="Booking No."
                    name="bookingId"
                    className="ant-select  bg-black text-white  inpTxt mt-5 p-1 h-9  w-52"
                    optionFilterProp="children"
                    value={state.bookingId || "Booking No."}
                    onChange={(e) => {
                      const _party = state.bookings.find(
                        (el) => el.BookingID === e
                      );
                      if (_party) {
                        setState({
                          ...state,
                          bookingId: e,
                        });
                      } else {
                        setState({
                          ...state,
                          bookingId: e,
                        });
                      }
                    }}
                  >
                    <Option value={0}>None</Option>
                    {state.bookings.map((el) => (
                      <Option
                        value={el.BookingID}
                      >{`${el.BookingID} - ${el.CName}`}</Option>
                    ))}
                  </Select>
                </div>

                   <div className="ml-3 mt-5">
                  <label className="text-white">Report Type:</label>
                  <Select
                    className="ml-3 w-40"
                    value={state.reportType}
                    onChange={(value) =>
                      setState({ ...state, reportType: value })
                    }
                  >
                    <Option value="0">Booking Wise</Option>
                    <Option value="1">Event Wise</Option>
                  </Select>
                </div>
                </div>
                <div>
                  <button
                    className={`bg-blue-500 text-white mt-2 ml-3 py-1 px-4 rounded ${
                      loading
                        ? "opacity-50 cursor-not-allowed"
                        : "hover:bg-blue-700"
                    }`}
                    onClick={editHandler}
                    disabled={loading}
                  >
                    {loading ? "Loading..." : "View"}
                  </button>
                  <button
                    className="bg-blue-500 hover:bg-blue-700 text-white mt-3 ml-3 py-1 px-4 rounded"
                    onClick={clearState}
                  >
                    Clear
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BookingEvents;
